import React from 'react';
import { Link } from 'react-router-dom';
import Modal from '../common/Modal';

const PERMISSION_GROUPS = [
  {
    title: 'Your Profile',
    items: [
      'Access your basic Facebook profile (name, profile picture)',
      'Access the email address linked to your Facebook account',
    ],
  },
  {
    title: 'Your Facebook Pages',
    items: [
      'See the list of Pages you manage',
      'Read engagement data on your Pages',
      'Create, edit, and schedule posts on your Pages',
      'Read content on your Pages (needed for Stories)',
    ],
  },
  {
    title: 'Your Instagram Account',
    items: [
      'Access your linked Instagram business account info',
      'Publish posts and stories to your Instagram account',
    ],
  },
  {
    title: 'Business Management',
    items: [
      'Access business management features (required for Facebook Stories)',
    ],
  },
];

function MetaConsentModal({ isOpen, onClose, onConfirm, isLoading }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Connect Meta Account">
      <div className="space-y-5 text-sm">
        <p className="text-cream/70 leading-relaxed">
          NextAInsight needs the following permissions to manage and publish content to your
          Facebook Pages and Instagram accounts on your behalf.
        </p>

        <div className="space-y-4">
          {PERMISSION_GROUPS.map((group) => (
            <div key={group.title} className="p-3 bg-white/5 rounded-xl border border-white/5">
              <h4 className="text-white font-bold text-xs uppercase tracking-wider mb-2">{group.title}</h4>
              <ul className="space-y-1.5">
                {group.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-cream/60">
                    <span className="text-slate-blue mt-0.5 text-xs">&#9679;</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="p-3 bg-slate-blue/10 rounded-xl border border-slate-blue/20">
          <p className="text-cream/60 leading-relaxed">
            <strong className="text-white">What we store:</strong> Your page access tokens are encrypted (AES-256)
            and used only to publish content you create. You can disconnect at any time in Settings.
          </p>
        </div>

        <div className="p-3 bg-soft-coral/10 rounded-xl border border-soft-coral/20">
          <p className="text-cream/60 leading-relaxed">
            <strong className="text-soft-coral">Before you connect:</strong> Make sure you've accepted the
            Facebook tester invitation first. Check your email for instructions. If you haven't received
            one yet, please wait — we'll send it once your access is ready.
          </p>
        </div>

        <p className="text-cream/40 text-xs">
          By connecting, you agree to our{' '}
          <Link to="/privacy-policy" className="text-slate-blue hover:underline" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </Link>
          {' '}regarding how we handle your Meta account data.
        </p>

        <div className="flex items-center justify-end gap-3 pt-2 border-t border-white/5">
          <button
            onClick={onClose}
            className="px-5 py-2.5 text-sm font-medium text-cream/50 hover:text-cream transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-6 py-2.5 text-sm font-bold text-white bg-slate-blue hover:bg-slate-blue/80 rounded-full transition-all shadow-glow disabled:opacity-50"
          >
            {isLoading ? 'Connecting...' : 'Connect to Meta'}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default MetaConsentModal;
